/**
 * SMRT Template Utilities
 *
 * Shared utility functions for product management functionality.
 */

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
}

export function formatDate(date: string | Date): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(dateObj);
}

export function slugify(text: string): string {
  return text
    .normalize('NFKD')
    .replace(/[^\p{L}\p{N} ]+/gu, '')
    .trim()
    .toLowerCase()
    .replace(/ +/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function generateId(): string {
  return Math.random().toString(36).substr(2, 9);
}
